const CounterModel = {
    fetchCounter: async () => {
      try {
        const response = await fetch(
          "https://v46javefxg.execute-api.eu-north-1.amazonaws.com/GetCounterLambda"
        );
        const data = await response.json();
        return data.counter;
      } catch (error) {
        console.error("Error fetching counter:", error);
      }
    },
  };
  
  export default CounterModel;
  